// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)
export default {
  'tv_outlined': {
    'micro': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 103,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 104,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 105,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 106,
        label: 'Talk about the ad to colleagues or employees',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 108,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 109,
        label: "Visit company's website for more info",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 112,
        label: 'Include this company in my next RFP process',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 113,
        label: 'Take a meeting with a sales rep',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 180,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 181,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 114,
        label: 'Purchase products/services from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 182,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 107,
        label: 'Ask associates about experiences with company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 110,
        label: 'Call for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 111,
        label: 'Respond to a mail solicitation from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 192,
        label: 'Ad Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 115,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 116,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 118,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 124,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'hb0'
      },
      // Brand Connection
      {
        metric: 126,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 183,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Portrays a brand I want to associate with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 130,
        label: `Meets my business's needs`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Reliable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 184,
        label: 'Partners with me to find the right business solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Trustworthy',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 131,
        label: 'Makes me feel good about this brand',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Cognitive Connection
      {
        metric: 144,
        label: 'Cognitive Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 151,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 149,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 145,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 185,
        label: 'Good fit with the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 148,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 146,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 147,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 150,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Engagement
      {
        metric: 159,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 164,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 160,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 166,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 186,
        label: 'More unique offers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 162,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 163,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 165,
        label: 'Memorable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 193,
        label: 'Appealing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 161,
        label: 'Unique',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 158,
        label: 'Heartwarming',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 167,
        label: 'Irritating',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Category Connection
      {
        metric: 132,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 138,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 187,
        label: 'Makes me feel secure',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 153,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 133,
        label: 'Innovative technology',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 135,
        label: 'Offers technologically advanced solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 188,
        label: 'Easy to do business with',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 136,
        label: 'Helps my business grow',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Relevance
      {
        metric: 139,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Relevant to my business',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 157,
        label: 'Provides peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 140,
        label: 'Relatable business people/situations',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 141,
        label: 'Addresses an issue that\'s important to my business',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Product Connection
      {
        metric: 152,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Products/features that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 137,
        label: 'Has products/services that work well together',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 189,
        label: 'Offers flexible plans to meet a variety of needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 190,
        label: 'Provides a great entertainment experience',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 191,
        label: 'Has a reliable network',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ],
    'mid': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 103,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 104,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 105,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 106,
        label: 'Talk about the ad to colleagues or employees',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 108,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 109,
        label: "Visit company's website for more info",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 112,
        label: 'Include this company in my next RFP process',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 113,
        label: 'Take a meeting with a sales rep',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 180,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 181,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 114,
        label: 'Purchase products/services from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 182,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 107,
        label: 'Ask associates about experiences with company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 110,
        label: 'Call for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 111,
        label: 'Respond to a mail solicitation from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 192,
        label: 'Ad Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 115,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 116,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 118,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 124,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'hb0'
      },
      // Brand Connection
      {
        metric: 126,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 183,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Portrays a brand I want to associate with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 130,
        label: `Meets my business's needs`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Reliable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 184,
        label: 'Partners with me to find the right business solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Trustworthy',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 131,
        label: 'Makes me feel good about this brand',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Cognitive Connection
      {
        metric: 144,
        label: 'Cognitive Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 151,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 149,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 145,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 185,
        label: 'Good fit with the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 148,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 146,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 147,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 150,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Engagement
      {
        metric: 159,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 164,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 160,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 166,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 186,
        label: 'More unique offers',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 162,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 163,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 165,
        label: 'Memorable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 193,
        label: 'Appealing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 161,
        label: 'Unique',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 158,
        label: 'Heartwarming',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 167,
        label: 'Irritating',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Category Connection
      {
        metric: 132,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 138,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 187,
        label: 'Makes me feel secure',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 153,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 133,
        label: 'Innovative technology',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 135,
        label: 'Offers technologically advanced solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 188,
        label: 'Easy to do business with',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 136,
        label: 'Helps my business grow',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Relevance
      {
        metric: 139,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Relevant to my business',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 157,
        label: 'Provides peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 140,
        label: 'Relatable business people/situations',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 141,
        label: 'Addresses an issue that\'s important to my business',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Product Connection
      {
        metric: 152,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Products/features that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 137,
        label: 'Has products/services that work well together',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 189,
        label: 'Offers flexible plans to meet a variety of needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 190,
        label: 'Provides a great entertainment experience',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 191,
        label: 'Has a reliable network',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ],
    'ent': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 103,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 104,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 105,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 106,
        label: 'Talk about the ad to colleagues or employees',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 108,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 109,
        label: "Visit company's website for more info",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 112,
        label: 'Include this company in my next RFP process',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 113,
        label: 'Take a meeting with a sales rep',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 180,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 181,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 114,
        label: 'Purchase products/services from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 182,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 107,
        label: 'Ask associates about experiences with company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 110,
        label: 'Call for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 111,
        label: 'Respond to a mail solicitation from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 192,
        label: 'Ad Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 115,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 116,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 118,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 124,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'hb0'
      },
      // Brand Connection
      {
        metric: 126,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 183,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Portrays a brand I want to associate with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 130,
        label: `Meets my business's needs`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Reliable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 184,
        label: 'Partners with me to find the right business solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Trustworthy',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 131,
        label: 'Makes me feel good about this brand',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Cognitive Connection
      {
        metric: 144,
        label: 'Cognitive Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 151,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 149,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 145,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 185,
        label: 'Good fit with the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 148,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 146,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 147,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 150,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Engagement
      {
        metric: 159,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 164,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 160,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 166,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 186,
        label: 'More unique offers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 162,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 163,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 165,
        label: 'Memorable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 193,
        label: 'Appealing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 161,
        label: 'Unique',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 158,
        label: 'Heartwarming',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 167,
        label: 'Irritating',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Category Connection
      {
        metric: 132,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 138,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 187,
        label: 'Makes me feel secure',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 153,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 133,
        label: 'Innovative technology',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 135,
        label: 'Offers technologically advanced solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 188,
        label: 'Easy to do business with',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 136,
        label: 'Helps my business grow',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Relevance
      {
        metric: 139,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Relevant to my business',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 157,
        label: 'Provides peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 140,
        label: 'Relatable business people/situations',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 141,
        label: 'Addresses an issue that\'s important to my business',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Product Connection
      {
        metric: 152,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Products/features that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 137,
        label: 'Has products/services that work well together',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 189,
        label: 'Offers flexible plans to meet a variety of needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 190,
        label: 'Provides a great entertainment experience',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 191,
        label: 'Has a reliable network',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ],
    'public_sector': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 103,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 104,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 105,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 106,
        label: 'Talk about the ad to colleagues or employees',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 108,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 109,
        label: "Visit company's website for more info",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 112,
        label: 'Include this company in my next RFP process',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 113,
        label: 'Take a meeting with a sales rep',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 180,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 181,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 114,
        label: 'Purchase products/services from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 182,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 107,
        label: 'Ask associates about experiences with company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 110,
        label: 'Call for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 111,
        label: 'Respond to a mail solicitation from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 192,
        label: 'Ad Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 115,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 116,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 118,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 124,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'hb0'
      },
      // Brand Connection
      {
        metric: 126,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 183,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Portrays a brand I want to associate with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 130,
        label: `Meets my business's needs`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Reliable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 184,
        label: 'Partners with me to find the right business solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Trustworthy',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 131,
        label: 'Makes me feel good about this brand',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Cognitive Connection
      {
        metric: 144,
        label: 'Cognitive Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 151,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 149,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 145,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 185,
        label: 'Good fit with the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 148,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 146,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 147,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 150,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Engagement
      {
        metric: 159,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 164,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 160,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 166,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 186,
        label: 'More unique offers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 162,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 163,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 165,
        label: 'Memorable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 193,
        label: 'Appealing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 161,
        label: 'Unique',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 158,
        label: 'Heartwarming',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 167,
        label: 'Irritating',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Category Connection
      {
        metric: 132,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 138,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 187,
        label: 'Makes me feel secure',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 153,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 133,
        label: 'Innovative technology',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 135,
        label: 'Offers technologically advanced solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 188,
        label: 'Easy to do business with',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 136,
        label: 'Helps my business grow',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Relevance
      {
        metric: 139,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Relevant to my business',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 157,
        label: 'Provides peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 140,
        label: 'Relatable business people/situations',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 141,
        label: 'Addresses an issue that\'s important to my business',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Product Connection
      {
        metric: 152,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Products/features that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 137,
        label: 'Has products/services that work well together',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 189,
        label: 'Offers flexible plans to meet a variety of needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 190,
        label: 'Provides a great entertainment experience',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 191,
        label: 'Has a reliable network',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  },
  'olv': {
    'micro': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 101,
        label: 'In-Feed Total Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 103,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 104,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 105,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 106,
        label: 'Talk about the ad to colleagues or employees',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 108,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 109,
        label: "Visit company's website for more info",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 112,
        label: 'Include this company in my next RFP process',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 113,
        label: 'Take a meeting with a sales rep',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 180,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 181,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 114,
        label: 'Purchase products/services from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 182,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 107,
        label: 'Ask associates about experiences with company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 110,
        label: 'Call for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 111,
        label: 'Respond to a mail solicitation from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 192,
        label: 'Ad Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 115,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 116,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 118,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 124,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'hb0'
      },
      // Brand Connection
      {
        metric: 126,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 183,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Portrays a brand I want to associate with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 130,
        label: `Meets my business's needs`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Reliable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 184,
        label: 'Partners with me to find the right business solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Trustworthy',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 131,
        label: 'Makes me feel good about this brand',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Cognitive Connection
      {
        metric: 144,
        label: 'Cognitive Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 151,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 149,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 145,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 185,
        label: 'Good fit with the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 148,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 146,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 147,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 150,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Engagement
      {
        metric: 159,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 164,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 160,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 166,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 186,
        label: 'More unique offers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 162,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 163,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 165,
        label: 'Memorable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 193,
        label: 'Appealing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 161,
        label: 'Unique',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 158,
        label: 'Heartwarming',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 167,
        label: 'Irritating',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Category Connection
      {
        metric: 132,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 138,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 187,
        label: 'Makes me feel secure',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 153,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 133,
        label: 'Innovative technology',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 135,
        label: 'Offers technologically advanced solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 188,
        label: 'Easy to do business with',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 136,
        label: 'Helps my business grow',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Relevance
      {
        metric: 139,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Relevant to my business',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 157,
        label: 'Provides peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 140,
        label: 'Relatable business people/situations',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 141,
        label: 'Addresses an issue that\'s important to my business',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Product Connection
      {
        metric: 152,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Products/features that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 137,
        label: 'Has products/services that work well together',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 189,
        label: 'Offers flexible plans to meet a variety of needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 190,
        label: 'Provides a great entertainment experience',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 191,
        label: 'Has a reliable network',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ],
    'mid': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 101,
        label: 'In-Feed Total Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 103,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 104,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 105,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 106,
        label: 'Talk about the ad to colleagues or employees',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 108,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 109,
        label: "Visit company's website for more info",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 112,
        label: 'Include this company in my next RFP process',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 113,
        label: 'Take a meeting with a sales rep',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 180,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 181,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 114,
        label: 'Purchase products/services from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 182,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 107,
        label: 'Ask associates about experiences with company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 110,
        label: 'Call for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 111,
        label: 'Respond to a mail solicitation from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 192,
        label: 'Ad Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 115,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 116,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 118,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 124,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'hb0'
      },
      // Brand Connection
      {
        metric: 126,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 183,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Portrays a brand I want to associate with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 130,
        label: `Meets my business's needs`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Reliable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 184,
        label: 'Partners with me to find the right business solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Trustworthy',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 131,
        label: 'Makes me feel good about this brand',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Cognitive Connection
      {
        metric: 144,
        label: 'Cognitive Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 151,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 149,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 145,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 185,
        label: 'Good fit with the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 148,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 146,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 147,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 150,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Engagement
      {
        metric: 159,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 164,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 160,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 166,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 186,
        label: 'More unique offers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 162,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 163,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 165,
        label: 'Memorable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 193,
        label: 'Appealing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 161,
        label: 'Unique',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 158,
        label: 'Heartwarming',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 167,
        label: 'Irritating',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Category Connection
      {
        metric: 132,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 138,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 187,
        label: 'Makes me feel secure',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 153,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 133,
        label: 'Innovative technology',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 135,
        label: 'Offers technologically advanced solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 188,
        label: 'Easy to do business with',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 136,
        label: 'Helps my business grow',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Relevance
      {
        metric: 139,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Relevant to my business',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 157,
        label: 'Provides peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 140,
        label: 'Relatable business people/situations',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 141,
        label: 'Addresses an issue that\'s important to my business',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Product Connection
      {
        metric: 152,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Products/features that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 137,
        label: 'Has products/services that work well together',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 189,
        label: 'Offers flexible plans to meet a variety of needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 190,
        label: 'Provides a great entertainment experience',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 191,
        label: 'Has a reliable network',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ],
    'ent': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 101,
        label: 'In-Feed Total Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 103,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 104,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 105,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 106,
        label: 'Talk about the ad to colleagues or employees',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 108,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 109,
        label: "Visit company's website for more info",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 112,
        label: 'Include this company in my next RFP process',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 113,
        label: 'Take a meeting with a sales rep',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 180,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 181,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 114,
        label: 'Purchase products/services from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 182,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 107,
        label: 'Ask associates about experiences with company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 110,
        label: 'Call for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 111,
        label: 'Respond to a mail solicitation from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 192,
        label: 'Ad Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 115,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 116,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 118,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 124,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'hb0'
      },
      // Brand Connection
      {
        metric: 126,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 183,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Portrays a brand I want to associate with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 130,
        label: `Meets my business's needs`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Reliable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 184,
        label: 'Partners with me to find the right business solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Trustworthy',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 131,
        label: 'Makes me feel good about this brand',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Cognitive Connection
      {
        metric: 144,
        label: 'Cognitive Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 151,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 149,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 145,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 185,
        label: 'Good fit with the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 148,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 146,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 147,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 150,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Engagement
      {
        metric: 159,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 164,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 160,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 166,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 186,
        label: 'More unique offers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 162,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 163,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 165,
        label: 'Memorable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 193,
        label: 'Appealing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 161,
        label: 'Unique',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 158,
        label: 'Heartwarming',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 167,
        label: 'Irritating',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Category Connection
      {
        metric: 132,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 138,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 187,
        label: 'Makes me feel secure',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 153,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 133,
        label: 'Innovative technology',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 135,
        label: 'Offers technologically advanced solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 188,
        label: 'Easy to do business with',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 136,
        label: 'Helps my business grow',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Relevance
      {
        metric: 139,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Relevant to my business',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 157,
        label: 'Provides peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 140,
        label: 'Relatable business people/situations',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 141,
        label: 'Addresses an issue that\'s important to my business',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Product Connection
      {
        metric: 152,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Products/features that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 137,
        label: 'Has products/services that work well together',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 189,
        label: 'Offers flexible plans to meet a variety of needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 190,
        label: 'Provides a great entertainment experience',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 191,
        label: 'Has a reliable network',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ],
    'public_sector': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 101,
        label: 'In-Feed Total Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 103,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 104,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 105,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 106,
        label: 'Talk about the ad to colleagues or employees',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 108,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 109,
        label: "Visit company's website for more info",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 112,
        label: 'Include this company in my next RFP process',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 113,
        label: 'Take a meeting with a sales rep',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 180,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 181,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 114,
        label: 'Purchase products/services from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 182,
        label: 'Take advantage of an offer or promotion',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 107,
        label: 'Ask associates about experiences with company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 110,
        label: 'Call for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 111,
        label: 'Respond to a mail solicitation from this company',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 192,
        label: 'Ad Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 115,
        label: 'Aided Brand Recognition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 116,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 118,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 124,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'hb0'
      },
      // Brand Connection
      {
        metric: 126,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 183,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Portrays a brand I want to associate with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 130,
        label: `Meets my business's needs`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Reliable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 184,
        label: 'Partners with me to find the right business solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Trustworthy',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 131,
        label: 'Makes me feel good about this brand',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Cognitive Connection
      {
        metric: 144,
        label: 'Cognitive Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 151,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 149,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 145,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 185,
        label: 'Good fit with the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 148,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 146,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 147,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 150,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Engagement
      {
        metric: 159,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 164,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 160,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 166,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 186,
        label: 'More unique offers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 162,
        label: 'Entertaining',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 163,
        label: 'Humorous',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 165,
        label: 'Memorable',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 193,
        label: 'Appealing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 161,
        label: 'Unique',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 158,
        label: 'Heartwarming',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 167,
        label: 'Irritating',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Category Connection
      {
        metric: 132,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 138,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 187,
        label: 'Makes me feel secure',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 153,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 133,
        label: 'Innovative technology',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 135,
        label: 'Offers technologically advanced solutions',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 188,
        label: 'Easy to do business with',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 136,
        label: 'Helps my business grow',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Relevance
      {
        metric: 139,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Relevant to my business',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 157,
        label: 'Provides peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 140,
        label: 'Relatable business people/situations',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 141,
        label: 'Addresses an issue that\'s important to my business',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      // Product Connection
      {
        metric: 152,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Products/features that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 137,
        label: 'Has products/services that work well together',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 189,
        label: 'Offers flexible plans to meet a variety of needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 190,
        label: 'Provides a great entertainment experience',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 191,
        label: 'Has a reliable network',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/TmobileBussiness/config/components/scorecard/MetricsLabels/metricsLabels.js